import React, { Component } from 'react';
import { Progress } from 'reactstrap';
import PropTypes from 'prop-types';
import { CartContext } from '../../components/ParadigmaCartProvider/ParadigmaCartProvider';
import functions from "../../api/functions.js";
import api from "../../api/api.js";

class FreeShipping extends Component {
    static contextType = CartContext;

    state = {
        costoEnvio: 0,
        localidadId: null
    };

    componentDidMount() {
        this.getProfile();
    }

    componentDidUpdate(prevProps, prevState) {
        const { totalPrice } = this.props;
        const { costoEnvio } = this.state;

        // console.log(totalPrice, costoEnvio)

        if (prevState.costoEnvio !== costoEnvio || prevProps.totalPrice !== totalPrice) {
            this.checkFreeShipping();
        }
    }

    checkFreeShipping() {
        const { totalPrice } = this.props;
        const formattedPrice = typeof totalPrice === 'number' ? totalPrice : parseInt(totalPrice.replace(/\./g, ''), 10);
        const { costoEnvio } = this.state;

        const remainingAmount = costoEnvio - formattedPrice;
        // console.log(remainingAmount)
        this.props.onRemainingAmount(remainingAmount);

        const hasFreeShipping = formattedPrice >= costoEnvio;
        // console.log(hasFreeShipping)
        this.props.onFreeShippingChange(hasFreeShipping);
    }

    getProfile() {
        functions.post(api.api.auth.profile, null, null, (data) => {
            // console.log(data);
            this.setState({
                costoEnvio: data.data.Costo_envio,
                localidadId: data.data.LocalidadesEnvio_id
            });
        });
    }

    render() {
        const { totalPrice } = this.props;
        const formattedPrice = typeof totalPrice === 'number' ? totalPrice : parseInt(totalPrice.replace(/\./g, ''), 10);
        const { costoEnvio, localidadId } = this.state;

        if (!localidadId || costoEnvio < 100000) {
            return null;
        }

        const remainingAmount = costoEnvio - formattedPrice;
        const percentage = Math.min((formattedPrice / costoEnvio) * 100, 100);

        return (
            this.props.type === 'cart' ? (
                <div className="w-100 d-flex align-items-center justify-content-center bg-white border border-gray-300 rounded-lg px-2 py-1">
                    <div className="mb-2">
                        {formattedPrice < costoEnvio ? (
                            <p>
                                Conseguí <span style={{ color: 'green' }}>envío gratis</span> sumando $
                                {remainingAmount} más en productos
                            </p>
                        ) : (
                            <p>
                                <span style={{ color: 'green' }}>Envío gratis</span>
                            </p>
                        )}
                        <Progress value={percentage} color="success" striped animated style={{ height: '10px' }} />
                    </div>
                </div>
            ) : (
                <div className="mb-2">
                    {formattedPrice < costoEnvio ? (
                        <p>
                            Conseguí <span style={{ color: 'green' }}>envío gratis</span> sumando $
                            {remainingAmount} más en productos
                        </p>
                    ) : (
                        <p>
                            <span style={{ color: 'green' }}>Envío gratis</span>
                        </p>
                    )}
                    <Progress value={percentage} color="success" striped animated style={{ height: '10px' }} />
                </div>
            )
        );
    }
}

FreeShipping.propTypes = {
    totalPrice: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired,
    onFreeShippingChange: PropTypes.func.isRequired,
    onRemainingAmount: PropTypes.func.isRequired,
    type: PropTypes.string,
};

export default FreeShipping;



// WEBPACK FOOTER //
// ./src/components/ShippingComponent/Shipping.js